import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { opacity: "0.7" }, [
      _createElementVNode("rect", {
        y: "6.33398",
        width: "14",
        height: "2",
        rx: "1",
        fill: "white"
      }),
      _createElementVNode("rect", {
        x: "8",
        width: "14",
        height: "2",
        rx: "1",
        transform: "rotate(90 8 0)",
        fill: "white"
      })
    ], -1)
  ]))]))
}
export default { render: render }